import { render, staticRenderFns } from "./ProductosComponent.vue?vue&type=template&id=61ab6ec0&scoped=true"
import script from "./ProductosComponent.vue?vue&type=script&lang=js"
export * from "./ProductosComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductosComponent.vue?vue&type=style&index=0&id=61ab6ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab6ec0",
  null
  
)

export default component.exports